import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigsLoaderService} from "./config-loader.service";
import {Item} from "../models/item.inferface";
import { Observable } from 'rxjs';
import {Form} from "../models/form";

@Injectable({providedIn: 'root'})
export class LanguageService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient,
    private config: ConfigsLoaderService,
    ) {
    this.apiUrl = `${this.config.apiUrl}/Language/`;
  }

  getList(): Observable<any>{
    return this.httpClient.get<any>(`${this.apiUrl}List`);
  }

  getNeedToUpdateLanguage(id,lastModifiedDate): Observable<any>{
    return this.httpClient.get<any>(`${this.apiUrl}NeedToUpdateLanguage/${id}/${lastModifiedDate}`);
  }

  getFullLanguage(id): Observable<any>{
    return this.httpClient.get<any>(`${this.apiUrl}GetFullLanguage/`+id);
  }
}